import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
    Button,
    Navbar,
    Alignment,
    AnchorButton,
    Divider,
} from '@blueprintjs/core';
import { Button as MuiButton, Menu, MenuItem, Dialog as MuiDialog, DialogTitle, IconButton, DialogContent, DialogActions, TextField, Avatar, Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { downloadFile } from 'polotno/utils/download';
import { useHistory } from "react-router-dom";
import styled from 'polotno/utils/styled';
import { faSignOutAlt, faFile, faFolderOpen, faLink, faSave, faShareAlt, faArrowAltCircleDown, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { saveImg } from '../../../services';
import { logoEl } from './Logo';
const NavbarContainer = styled('div')`
  @media screen and (max-width: 500px) {
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100vw;
  }
`;

const NavInner = styled('div')`
  @media screen and (max-width: 500px) {
    display: flex;
  }
`;

export default observer(({ store }) => {
    const history = useHistory();
    const inputRef = useRef();
    const deFaultUrl = "https://apaxleadersgreetings-frames.vercel.app/shareImg/"
    const [isOpenShareDialog, setisOpenShareDialog] = useState(false);
    const [anchorMenu, setAnchorMenu] = useState(null);
    const [anchorMenuLogout, setanchorMenuLogout] = useState(null);
    const [linkImgShare, setlinkImgShare] = useState("")

    const handleSaveCloud = async () => {
        let logoElement = logoEl
        logoElement.x = store.width - 220
        logoElement.y = store.height - 70
        const logoAdd = store.activePage.addElement(logoElement);
        await store.waitLoading();
        const dataSaveImg = {
            sessionId: localStorage.getItem("sessionId"),
            image: store.toDataURL()
        }
        store.deleteElements([logoAdd.id]);
        saveImg(dataSaveImg).then(res => {
            if (res.data.responseCode == 200) {
                let linkImg = deFaultUrl
                linkImg += res.data.data.imgId
                setlinkImgShare(linkImg)
                setAnchorMenu(null)
                setisOpenShareDialog(true)
            }
            else {

            }
        })
    }

    const handlSaveLocal = async () => {
        let logoElement = logoEl
        logoElement.x = store.width - 220
        logoElement.y = store.height - 70
        const logoAdd = store.activePage.addElement(logoElement);
        await store.waitLoading();
        store.saveAsImage({ fileName: 'export.png' });
        store.deleteElements([logoAdd.id]);
        const dataSaveImg = {
            sessionId: localStorage.getItem("sessionId"),
            image: "export"
        }
        saveImg(dataSaveImg).then(res => {

        })
    }

    const handleOpenLogOutMenu = (event) => {
        setanchorMenuLogout(event.currentTarget);
    };

    const handleLogOut = () => {
        setanchorMenuLogout(null)
        const pagesIds = store.pages.map((p) => p.id);
        store.deletePages(pagesIds);
        localStorage.removeItem("sessionId")
        history.push("/")
    }

    return (
        <NavbarContainer className="bp3-navbar">
            <NavInner>
                <Navbar.Group align={Alignment.LEFT}>
                  
{/* 
                    <label htmlFor="load-project">
                        <MuiButton
                            style={{ marginLeft: "1em" }}
                            variant="contained"
                            icon="folder-open"
                            onClick={() => {
                                document.querySelector('#load-project').click();
                            }}
                        >
                            <div>

                                <FontAwesomeIcon icon={faFolderOpen} style={{ marginRight: "2px" }} />
                                <span>
                                    Open
                                </span>
                            </div>
                        </MuiButton>
                        <input
                            type="file"
                            id="load-project"
                            accept=".json,.polotno"
                            ref={inputRef}
                            style={{ width: '180px', display: 'none' }}
                            onChange={(e) => {
                                var input = e.target;

                                if (!input.files.length) {
                                    return;
                                }

                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    var text = reader.result;
                                    let json;
                                    try {
                                        json = JSON.parse(text);
                                    } catch (e) {
                                        alert('Can not load the project.');
                                    }

                                    if (json) {
                                        store.loadJSON(json);
                                    }
                                };
                                reader.onerror = function () {
                                    alert('Can not load the project.');
                                };
                                reader.readAsText(input.files[0]);
                            }}
                        />
                    </label>
                    <MuiButton
                        variant="contained"
                        style={{ marginLeft: "1em", marginRight: "1em" }}
                        onClick={() => {

                            const json = store.toJSON();

                            const url =
                                'data:text/json;base64,' +
                                window.btoa(unescape(encodeURIComponent(JSON.stringify(json))));
                            downloadFile(url, 'exportTemplate.json');
                        }}
                    >
                        <div>

                            <FontAwesomeIcon icon={faSave} style={{ marginRight: "2px" }} />
                            <span>
                                Save
                            </span>
                        </div>
                    </MuiButton> */}
                    <a href="https://www.apaxleaders.edu.vn/" target="_blank" style={{ height: "100%", padding: "5px 0" }}>
                        <img src="/img/logo.png" alt="" style={{ height: "100%" }} />
                    </a>
                </Navbar.Group>
                <Navbar.Group align={Alignment.RIGHT}>
   <MuiButton

                        variant="contained"
                        onClick={() => {
                            const ids = store.pages
                                .map((page) => page.children.map((child) => child.id))
                                .flat();
                            const hasObjects = ids?.length;
                            if (hasObjects) {
                                if (!window.confirm('Remove all content for a new design?')) {
                                    return;
                                }
                            }
                            const pagesIds = store.pages.map((p) => p.id);
                            store.deletePages(pagesIds);
                            store.addPage();
                        }}
                    >
                        <div>

                            <FontAwesomeIcon icon={faFile} style={{ marginRight: "2px" }} />
                            <span>
                                New
                            </span>
                        </div>
                    </MuiButton>
                    <MuiButton style={{ marginRight: "10px" , marginLeft:"10px"   }} variant="contained" color="info" onClick={(e) => setAnchorMenu(e.currentTarget)}>
                        <div>
                            <FontAwesomeIcon icon={faShareAlt} style={{ marginRight: "2px" }} />
                            <span>
                                Share
                            </span>
                        </div>
                    </MuiButton>
                    <IconButton onClick={(e) => handleOpenLogOutMenu(e)}>
                        <FontAwesomeIcon icon={faSortDown} style={{ marginBottom: "50%" }} />
                    </IconButton>
                    <Menu

                        anchorEl={anchorMenuLogout}
                        open={Boolean(anchorMenuLogout)}
                        onClose={() => setanchorMenuLogout(null)}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={() => handleLogOut()}>Sign out</MenuItem>
                    </Menu>

                    <Menu
                        id="basic-menu"
                        anchorEl={anchorMenu}
                        open={Boolean(anchorMenu)}
                        onClose={() => setAnchorMenu(null)}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleSaveCloud}>Share link</MenuItem>
                        <MenuItem onClick={handlSaveLocal}>Save to png</MenuItem>
                        {/* <MenuItem onClick={handleCloseMenu}>Logout</MenuItem> */}
                    </Menu>
                </Navbar.Group>
            </NavInner>
            <MuiDialog
                fullWidth={true}
                maxWidth={'sm'}
                open={isOpenShareDialog} onClose={() => setisOpenShareDialog(false)}>
                <DialogTitle>
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <Avatar style={{ backgroundColor: "#4285f4", marginRight: "10px" }}>
                            <FontAwesomeIcon icon={faLink} />
                        </Avatar>
                        <h4 style={{ marginTop: "10px", marginBottom: "5px" }}>
                            Share with your beloved people!
                        </h4>
                    </div></DialogTitle>
                <DialogContent style={{ paddingBottom: "10px" }}>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ width: "80%", backgroundColor: "#f1f3f4", marginRight: "10px" }}>

                            <TextField
                                style={{
                                    paddingLeft: "10px", letterSpacing: " .01428571em",
                                    fontFamily: " Roboto,Arial,sans-serif",
                                    fontSize: ".875rem",
                                    fontWeight: "400"
                                }}
                                autoFocus
                                margin="dense"
                                id="name"
                                value={linkImgShare}
                                fullWidth
                                read
                                inputProps={
                                    { readOnly: true, }
                                }
                                // disabled
                                variant="standard"
                            />
                        </div>
                        <MuiButton style={{ width: "20%", marginTop: "10px" }} onClick={() => { navigator.clipboard.writeText(linkImgShare) }}>
                            <span style={{ textTransform: "none", fontWeight: "bold" }}>

                                Copy link
                            </span>
                        </MuiButton>
                    </div>
                </DialogContent>
                <DialogActions>
                    <MuiButton variant="contained" onClick={() => setisOpenShareDialog(false)}>Done</MuiButton>
                </DialogActions>
            </MuiDialog>
        </NavbarContainer>
    );
});
